export default __webpack_public_path__ + "static/media/percent-not.ab440a2b.svg";